import MainFiltersBQ from "../../../../Global/Models/Filters/MainFiltersBQ";

export type PostsSortTypes = "OLDEST" | "LATEST" | "INTERACTED" | "POPULAR";

export default class PostsFilters extends MainFiltersBQ {
  public skipDeleted?: boolean;
  public skipModerated?: boolean;
  public sort?: PostsSortTypes;

  constructor(filters: any) {
    super(filters);
    this.skipDeleted =
      filters && filters.skipDeleted !== undefined ? filters.skipDeleted : null;
    this.skipModerated =
      filters && filters.skipModerated !== undefined
        ? filters.skipModerated
        : null;
    this.sort =
      filters && filters.sort ? filters.sort.toLocaleLowerCase() : null;
  }

  constructMainFiltersUrl?(): string {
    let url = super.constructMainFiltersUrl();

    if (this.skipDeleted !== null) {
      url += `&skip_deleted=${this.skipDeleted}`;
    }
    if (this.skipModerated !== null) {
      url += `&skip_moderated=${this.skipModerated}`;
    }
    if (this.sort) {
      url += `&sort=${this.sort}`;
    }

    return url;
  }
}
